import React from 'react'
import completed from '../../../assets/images/checklist.png'
import finishTime from '../../../assets/images/finish-time.png'

const EvaluationCompleted = ({translate,type}) => {
  console.log(type);
  return (
    <div className='EvaluationCompleted'>
      {type === "finishTime" ? (
        <>
          <img src={finishTime} />
          <p>{translate('evaluation-expired')}</p>
        </>
      ) : (
        <>
          <img src={completed} />
          <p>{translate('evaluation-completed')}</p>
        </>
      )}
    </div>
  );
};


export default EvaluationCompleted